import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

const useRequirementsParams = () => {
  const location = useLocation();
  return useMemo(() => {
    const qp = queryString.parse(location.search);
    return {
      year: qp['filter-year'] ? Number.parseInt(qp['filter-year'], 10) : null,
      fedStandardCode:
        qp['filter-fedStandardCode'] || qp.fedStandardCode || '',
      standardItemNumber: qp['filter-standardItem'] || '',
    };
  }, [location.search]);
};

export default useRequirementsParams;
